import customerActions from "./customerActions";
const allActionsCustomers = {
  customerActions,
};

export default allActionsCustomers;
